export default "__VITE_ASSET__Cj$Sm6dD__"